<script setup lang="ts">
import { EllipsisVerticalIcon } from '@heroicons/vue/24/solid'
import { ref, useAttrs } from 'vue'

import ContextMenu from '../overlays/ContextMenu.vue'

const {
  blackTextColor = false,
  menuAlign = 'left',
  showBorder = false,
  visibility = 'hover',
} = defineProps<{
  blackTextColor?: boolean
  menuAlign?: 'left' | 'right'
  showBorder?: boolean
  threeDotsClasses?: string
  visibility?: 'allways' | 'hover'
}>()

defineSlots<{
  actions(): string
  default(): string
}>()

const menuOpen = ref(false)
const toggleMenuOpen = (): void => {
  menuOpen.value = !menuOpen.value
}
const closeMenu = (): void => {
  if (menuOpen.value) {
    menuOpen.value = false
  }
}
const attributesUse = useAttrs()

const { class: classAttr } = attributesUse
</script>

<template>
  <div>
    <div class="group relative cursor-pointer">
      <slot name="default"></slot>

      <div
        class="absolute"
        :class="[
          classAttr ?? 'right-4 top-1/2 -translate-y-1/2',
          visibility === 'hover' && !menuOpen ? 'hidden group-hover:block' : 'block',
          menuOpen ? 'z-10' : 'z-auto',
        ]"
      >
        <div
          v-click-outside="closeMenu"
          class="relative rounded-full p-1.5"
          :class="`${menuOpen ? `bg-black-100` : `bg-transparent`} ${blackTextColor ? 'text-black-600 hover:text-black-900' : 'text-lochmara-600 hover:text-lochmara-900'} ${showBorder ? 'border' : ''}`"
          @click="toggleMenuOpen"
        >
          <EllipsisVerticalIcon :class="`${threeDotsClasses} h-5 w-5`" />
          <ContextMenu :align="menuAlign" class="*:w-full" :open="menuOpen">
            <slot name="actions"></slot>
          </ContextMenu>
        </div>
      </div>
    </div>
  </div>
</template>
